import React, { useContext, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Stack, useMediaQuery } from '@mui/material';
import { useApolloClient } from '@apollo/client';
// import getConfig from 'next/config';
import { useToggle } from '../../../../hooks/useToggle';
import useLocalStorage, {
  clearJourneyLocalStorage,
  hasLocalStorageValue,
  removeLocalStorageWithPrefix,
  setCode,
} from '../../../../hooks/useLocalStorage';
import EirDeviceContainer from '../../../../components/eir-device-list/EirDeviceContainer';
import {
  fillDropdown,
  onLoadValuesInitializer,
  crossSellOrChangeOfferOnLoadEligibilityChecker,
} from '../../../../components/eir-device-list/handsetsFunctionContainer';
import getStrapiData from '../../../../integration/strapi';

import {
  onGetStandaloneHandsets,
  // onload,
} from '../../../../components/eir-mobile-offer-container/standalonedevice.util';
import ExistingCustomerCheckStandaloneHandset from '../../../../components/eir-existing-customer-check/ExistingCustomerCheckStandaloneHandset';
import RootContext from '../../../../../util/root.context';
import getCarts from '../../../../integration/cart.api';
import validateCart from '../../../../components/shared/validateCart';
import { mobileEligibilityCheck } from '../../../../components/shared/eligibilityCheck';
import {
  clearAllCookies,
  getCookie,
  getTokenFromCookies,
  setCookie,
} from '../../../../hooks/useCookie';
import LoginModal from '../../../../components/eir-login/LoginModal';
import { changeOfferMobileRequest } from '../../../../integration/change-offer.api';
import NavBar from '../../../../components/eir-nav-bar/NavBar';
import NavBarTitle from '../../../../components/eir-nav-bar/NavBarTitle';
import MobileDropDownMenu from '../../../../components/eir-dropdown-menu/MobileDropDownMenu';
import SubscriptionSelectionModal from '../../../../components/eir-change-offer/SubscriptionSelectionModal';
import EirJourneyPickerModal from '../../../../components/eir-journey-picker/EirJourneyPickerModal';
import EirWebchatModal from '../../../../components/eir-mobile-offer-container/EirWebchatModal';
import EirAbondonJourney from '../../../../components/eir-abondon-journey-modal/EirAbondonJourney';
// import { onLoadValuesInitializer } from '../../../../components/eir-mobile-offer-container/mobileFunctionContainer';
import EirRegistrationRequiredModal from '../../../../components/eir-login/EirRegistrationRequiredModal';
import UANErrorModal from '../../../../components/eir-ascertain-service/UANErrorModal';
import EirMetaTag from '../../../../components/eir-meta-tag/EirMetaTag';
import FaqContainer from '../../../../components/eir-mobile-broadband/FaqContainer';
import styles from '../../../../components/eir-device-list/styles';
import EirHeader from '../../../../components/eir-header/EirHeader';
import EirFooter from '../../../../components/eir-footer/EirFooter';
import ErrorModal from '../../../../components/eir-error-modal/ErrorModal';
import ApiFailureModal from '../../../../components/eir-error-modal/ApiFailureModal';
import MobileUpgradeIneligibleModal from '../../../../components/eir-mobile-upgrade-ineligible/MobileUpgradeIneligibleModal';
import MfaOtpModal from '../../../../components/eir-login/MfaOtpModal';
import MfaSuccessModal from '../../../../components/eir-login/MfaSuccessModal';

// const { publicRuntimeConfig } = getConfig();

export async function getServerSideProps({ req }) {
  let cmsData = {};
  let eligibility = {};
  let journeyData = {};
  let cmsHeaderData = {};
  let cmsFooterData = {};
  let error = '';

  try {
    cmsData = await getStrapiData('mobile');
    cmsHeaderData = await getStrapiData('header');
    cmsFooterData = await getStrapiData('footer');
    journeyData = await validateCart(req.cookies);
    if (journeyData.token) {
      eligibility = await mobileEligibilityCheck({ token: journeyData.token });
      eligibility = JSON.stringify(eligibility);
    }
  } catch (err) {
    eligibility = JSON.stringify(eligibility);
    error = err.message;
  }
  return {
    props: {
      cmsData,
      eligibility,
      journeyData,
      cmsHeaderData,
      cmsFooterData,
      error,
    },
  };
}

const Handsets = ({ cmsData, journeyData, eligibility, cmsHeaderData, cmsFooterData }) => {
  const theme = useTheme();
  const [openError, setOpenError] = useState(false);
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const openAPIFailureModal = useToggle(false);
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);
  const openAccountCheck = useToggle(false);
  const openJourneyPicker = useToggle(false);
  const upgradeIneligible = useToggle(false);
  const mfaOtpModal = useToggle(false);
  const mfaSuccessModal = useToggle(false);
  const [onLoadingDisablecta, setOnLoadingDisablecta] = useState(false);
  const [customerEligibility, setCustomerEligibility] = useState({});
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [dropdownContent, setDropdownContent] = useState([]);
  const [subscriptionId, setSubscriptionId] = useState();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const registrationIncompleteModal = useToggle(false);
  const [coMobileSubscriptions, setCoMobileSubscriptions] = useState([]);
  const enableWebChat = useToggle(false);
  const errorModalMaxOccurence = 2;
  const openAbondonModal = useToggle(false);
  const [clearJourney, setClearJourney] = useState(false);
  const [journeyType, setJourneyType] = useState('');
  const [journeyCrossOver, setJourneyCrossOver] = useState(false);
  const errorModal = useToggle(false);
  const [onLoadError, setOnLoadError] = useState(false);
  const isR6Customer = useToggle(false);
  const [otpUUID, setOtpUUID] = useState('');
  const [delivery, setDelivery] = useState('');
  // const [coEligibility, setCOEligibility] = useState(false);
  const graphql = useApolloClient();
  const localStore = useLocalStorage();
  const handleOk = () => {
    openAPIFailureModal.disable();
  };
  const [state, setState] = useState({
    devices: [],
    brands: [],
    selectedMobileOffer: null,
  });
  const [loader, setLoader] = useState(true);
  const [loginModal, setLoginModal] = useState(false);
  const [userValue, setUserValue] = useState('');
  const { state: rootState, dispatch } = useContext(RootContext);

  const onPageLoad = async selectedSubscriptionOffer => {
    setLoader(true);

    const { result, error } = await onGetStandaloneHandsets({
      graphql,
      localStorage: localStore,
      selectedSubscriptionOffer,
    });
    if (result && !error) {
      setOpenError(false);
      setErrorModalOccurence(0);
      errorModal.disable();
      openAPIFailureModal.disable();
      let variable = {};
      variable = {
        reference:
          getCookie('reference') ||
          localStore.getLocalStorage('REF') ||
          localStore.getLocalStorage('prospectuuid'),
        cartType: getCookie('cart_Type'),
        token: getTokenFromCookies(),
      };
      if (!getCookie('cart_Type')) delete variable.cartType;
      const { getCart: cart } = await getCarts({
        graphql,
        variables: variable,
      });
      dispatch({ type: 'SET_CART', payload: cart });
      setState({
        ...state,
        devices: result.getHandsets.handsets,
        brands: result.getHandsets.manufacturers,
        backEndOfferId: result?.getHandsets?.cartOfferID,
      });
      if (
        getCookie('cart_Type') === 'CHANGE_OFFER' &&
        cart?.offers?.filter(offer => offer.baseOffer.serviceGroup === 'MOBILE')[0].equipments
          .length > 0
      ) {
        console.log('Change Offer Cart Update');
      } else {
        localStore.setLocalStorage('HANDSET_BE_OFFERID', result?.getHandsets?.cartOfferID);
      }
      const defaultStandaloneHandsetTariff =
        cart?.offers?.filter(obj => obj?.id === parseInt(result?.getHandsets?.cartOfferID, 10))
          .length === 1 &&
        cart?.offers?.filter(obj => obj?.baseOffer?.serviceGroup === 'MOBILE').length === 1;
      if (defaultStandaloneHandsetTariff && !getTokenFromCookies()) {
        dispatch({ type: 'ENABLE_LOGIN_BUTTON', payload: true });
      }
    } else {
      setOpenError(true);
      errorModal.enable();
      setErrorModalOccurence(errorModalOccurence + 1);
      openAPIFailureModal.enable();
      // console.error('something went wrong getting handsets,', error);
      setOnLoadError(true);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('found-403')) errorModal.enable();
      if (!getCookie('token-missing')) errorModal.enable();
      console.error('something went wrong getting handsets,', error);
    }

    setLoader(false);
  };
  const crossSellHandsetJourney = async () => {
    clearJourneyLocalStorage('ACQ');
    setCode('CS');
    setCookie('ION', 'cart_Type', 'CROSS_SELL');
    onPageLoad();
    openJourneyPicker.disable();
    setLoginModal(false);
  };

  const changeOfferJourney = async (id, coSingleEligibleDetails) => {
    if (id) {
      if (getCookie('cart_Type') === 'CHANGE_OFFER' && getCookie('channel') === 'MYEIR') {
        const subscriptionOffer =
          customerEligibility?.subscriptions
            ?.filter(subscription => subscription.serviceGroup === 'MOBILE')
            ?.filter(sg => sg?.id === id) || coSingleEligibleDetails?.filter(sg => sg?.id === id);
        onPageLoad(subscriptionOffer[0]);
      } else {
        const { result, error } = await changeOfferMobileRequest({
          graphql,
          subscriptionId: id,
          channel: 'ESHOP', // only ESHOP works for create change Offer,
          email: getCookie('email_Address'),
        });
        if (error) {
          // To show error modal when journey starts from mobile/bill-pay/upgrades
          if (getCookie('UPGRADE_NUMBER')) {
            isR6Customer.enable(); // Used existing modal to show chat now enable web chat since the contents are same
          }
        }
        if (result) {
          const subscriptionOffer =
            customerEligibility?.subscriptions
              ?.filter(subscription => subscription.serviceGroup === 'MOBILE')
              ?.filter(sg => sg?.id === id) || coSingleEligibleDetails?.filter(sg => sg?.id === id);
          // setSubscriptionId(id);
          setSubscriptionId(id);
          setShowSubscriptionModal(false);
          clearJourneyLocalStorage('ACQ');
          setCode('CO');
          setCookie('ION', 'cart_Type', 'CHANGE_OFFER');
          onPageLoad(subscriptionOffer[0]);
          openJourneyPicker.disable();
          removeLocalStorageWithPrefix('ION_UPGRADE_NUMBER');
        }
      }
    } else {
      crossSellHandsetJourney();
    }
  };

  /* checking customer eligibility */
  const onMobileJourneyLogin = async () => {
    let Eligibility = eligibility;
    Eligibility = eligibility.constructor !== Object ? JSON.parse(eligibility) : eligibility;
    if (Object.keys(Eligibility).length !== 0) setCustomerEligibility(Eligibility);
    if (Object.keys(Eligibility).length === 0 && Eligibility.constructor === Object) {
      if (getTokenFromCookies() && !getCookie('cart_Type')) {
        const CustomerEligibility = await mobileEligibilityCheck({ token: getTokenFromCookies() });
        if (Object.keys(CustomerEligibility?.contactDetails || {}).length === 0) {
          setLoginModal(false);
          setOnLoadError(true);
          setErrorModalOccurence(errorModalOccurence + 1);
          if (!getCookie('found-403')) errorModal.enable();
          if (!getCookie('token-missing')) errorModal.enable();
          openJourneyPicker.disable();
          return;
        }
        const filteredMobileSubs = CustomerEligibility?.subscriptions?.filter(
          sg => sg?.serviceGroup === 'MOBILE'
        );
        const coMobileEligible = filteredMobileSubs?.filter(
          ele =>
            ele?.coEligiblity?.contractRenewal === true &&
            ele?.coEligiblity?.earlyCeaseChargeList?.totalAmountVatIncluded <= 0
        );
        // If user is eligible for Co and cs both then open Journey picker,
        // else if only cs and no co then directly start cs journey,
        // else start only co journey---> if co =1 then directly start co journey else open subscription modal.
        if (!coMobileEligible?.length > 0) {
          if (
            CustomerEligibility?.crossSellEligibility?.serviceGroups?.filter(
              servicegrp => servicegrp.serviceGroup === 'MOBILE'
            )[0]?.eligible
          ) {
            setLoginModal(false);
            openJourneyPicker.disable();
            if (filteredMobileSubs.length > 0) upgradeIneligible.enable();
            crossSellHandsetJourney();
          } else {
            setLoginModal(false);
            enableWebChat.enable();
          }
        } else if (
          CustomerEligibility?.crossSellEligibility?.serviceGroups?.filter(
            servicegrp => servicegrp.serviceGroup === 'MOBILE'
          )[0]?.eligible
        ) {
          setCoMobileSubscriptions(coMobileEligible);
          fillDropdown({ mobileSubscription: coMobileEligible, setDropdownContent });
          setCustomerEligibility(CustomerEligibility);
          setLoginModal(false);
          openJourneyPicker.enable();
        } else {
          setCoMobileSubscriptions(coMobileEligible);
          fillDropdown({ mobileSubscription: coMobileEligible, setDropdownContent });
          setCustomerEligibility(CustomerEligibility);
          setLoginModal(false);
          if (coMobileEligible?.length === 1) {
            changeOfferJourney(coMobileEligible[0].id, coMobileEligible);
          } else {
            setShowSubscriptionModal(true);
          }
        }

        // mobileEligibilityCheck(eligibility);
      }
    } else if (getTokenFromCookies() && !getCookie('cart_Type')) {
      // const CustomerEligibility = await eligibilityCheck({ token: getTokenFromCookies() });
      if (Object.keys(Eligibility?.contactDetails || {}).length === 0) {
        setOnLoadError(true);
        setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('found-403')) errorModal.enable();
        if (!getCookie('token-missing')) errorModal.enable();
        openJourneyPicker.disable();
        return;
      }
      const filteredMobileSubs = Eligibility?.subscriptions?.filter(
        sg => sg?.serviceGroup === 'MOBILE'
      );
      const coMobileEligible = filteredMobileSubs?.filter(
        ele =>
          ele?.coEligiblity?.contractRenewal === true &&
          ele?.coEligiblity?.earlyCeaseChargeList?.totalAmountVatIncluded <= 0 // Not an ECC Customer, hence eligible for CHANGE OFFER
      );
      // If user is eligible for Co and cs both then open Journey picker,
      // else if only cs and no co then directly start cs journey,
      // else start only co journey---> if co =1 then directly start co journey else open subscription modal.
      if (!coMobileEligible?.length > 0) {
        if (
          Eligibility?.crossSellEligibility?.serviceGroups?.filter(
            servicegrp => servicegrp.serviceGroup === 'MOBILE'
          )[0]?.eligible
        ) {
          setLoginModal(false);
          openJourneyPicker.disable();
          upgradeIneligible.enable();
          crossSellHandsetJourney();
        } else {
          setLoginModal(false);
          enableWebChat.enable();
        }
      } else if (
        Eligibility?.crossSellEligibility?.serviceGroups?.filter(
          servicegrp => servicegrp.serviceGroup === 'MOBILE'
        )[0]?.eligible
      ) {
        setCoMobileSubscriptions(coMobileEligible);
        fillDropdown({ mobileSubscription: coMobileEligible, setDropdownContent });
        setCustomerEligibility(Eligibility);
        setLoginModal(false);
        openJourneyPicker.enable();
      } else {
        setCoMobileSubscriptions(coMobileEligible);
        fillDropdown({ mobileSubscription: coMobileEligible, setDropdownContent });
        setCustomerEligibility(Eligibility);
        setLoginModal(false);
        if (coMobileEligible?.length === 1) {
          changeOfferJourney(coMobileEligible[0].id, coMobileEligible);
        } else {
          setShowSubscriptionModal(true);
        }
      }

      // mobileEligibilityCheck(eligibility);
    }
  };

  const fetchInfo = async () => {
    const { openAccountCheckModal, openAbondonCheckModal } = onLoadValuesInitializer({
      journeyData,
      setCode,
      getTokenFromCookies,
      dispatch,
      localStore,
      hasLocalStorageValue,
      getCookie,
      setJourneyType,
      setState,
    });
    const { loadJourneyPickerModal, isCrossSellEligible, isChangeOfferEligible } =
      await crossSellOrChangeOfferOnLoadEligibilityChecker({
        eligibility,
        getTokenFromCookies,
        setCustomerEligibility,
        getLocalStorage: localStore.getLocalStorage,
        hasLocalStorageValue,
        mobileEligibilityCheck,
        setCoMobileSubscriptions,
        getCookie,
        setCookie,
        setDropdownContent,
      });
    if (openAccountCheckModal) {
      openAccountCheck.enable();
    } else if (openAbondonCheckModal) {
      openAbondonModal.enable();
      onPageLoad();
    } else if (loadJourneyPickerModal) openJourneyPicker.enable();
    else if (isCrossSellEligible) {
      upgradeIneligible.enable();
      crossSellHandsetJourney();
    } else if (isChangeOfferEligible.value) {
      if (isChangeOfferEligible?.CoEligiblenumber === 1) {
        changeOfferJourney(
          isChangeOfferEligible?.coEligiblityDetails[0].id,
          isChangeOfferEligible?.coEligiblityDetails
        );
      } else {
        changeOfferJourney(
          parseInt(getCookie('SUBSCRIPTION_ID'), 10),
          isChangeOfferEligible?.coEligiblityDetails
        );
      }
    } else onPageLoad();
  };

  useEffect(() => {
    if (getCookie('PREPAY_REFERENCE')) {
      clearAllCookies();
      localStorage.clear();
    }
  }, []);

  useEffect(() => {
    fetchInfo();
  }, []);

  useEffect(() => {
    if (coMobileSubscriptions?.length > 0) {
      fillDropdown({ mobileSubscription: coMobileSubscriptions, setDropdownContent });
      setSubscriptionId(parseInt(getCookie('SUBSCRIPTION_ID'), 10));
    }
  }, [coMobileSubscriptions]);
  useEffect(() => {
    if (journeyCrossOver) {
      onMobileJourneyLogin();
      openAccountCheck.disable();
      setJourneyCrossOver(false);
    }
  }, [journeyCrossOver]);
  useEffect(() => {
    if (rootState.displayLogin) {
      setLoginModal(true);
    }
  }, [rootState.displayLogin]);

  return (
    <Stack
      sx={{
        backgroundSize: '100%',
        backgroundColor: theme.palette.primary.backgroundColor2,
        minHeight: '100vh',
      }}
    >
      <EirMetaTag seo={cmsData?.data?.attributes?.Seo_MobileHandsets} />
      <EirHeader cmsHeaderData={cmsHeaderData?.data} />
      <main id='main' tabIndex={-1}>
        {openAccountCheck.value && (
          <ExistingCustomerCheckStandaloneHandset
            openAccountCheck={openAccountCheck}
            cmsData={cmsData?.data}
            setLoginModal={setLoginModal}
            dispatch={dispatch}
            onPageLoad={onPageLoad}
            setLoader={setLoader}
          />
        )}
        {getCookie('cart_Type') === 'CHANGE_OFFER' && (
          <NavBar
            additionalStyles={getCookie('cart_Type') === 'CHANGE_OFFER'}
            headerText={
              <>
                <NavBarTitle
                  title='Which mobile would you like to change?'
                  style={
                    !sm && {
                      title: { marginRight: '32px' },
                    }
                  }
                />{' '}
                <MobileDropDownMenu
                  numbers={dropdownContent}
                  changeOfferJourney={changeOfferJourney}
                  additionalStyles
                  setSubscriptionId={setSubscriptionId}
                  subscriptionId={subscriptionId}
                  disableAltcta={
                    !customerEligibility?.crossSellEligibility?.serviceGroups?.filter(
                      servicegrp => servicegrp.serviceGroup === 'MOBILE'
                    )[0]?.eligible
                  }
                />
              </>
            }
          />
        )}
        <Grid container justifyContent='center'>
          {state?.devices && (
            <Grid item xs={12}>
              <EirDeviceContainer
                devices={state.devices}
                brands={state.brands}
                loading={loader}
                cmsData={cmsData.data}
                isHandset
              />
              {cmsData?.data?.attributes?.Handsets_FAQ_List.length > 0 && (
                <Grid
                  xs={12}
                  sx={{
                    background: theme.palette.primary.backgroundColor3,
                    ...styles(theme).faqContainerSuperMain,
                  }}
                >
                  <FaqContainer
                    InsuranceHeading={cmsData?.data?.attributes?.Handsets_FAQ_Title}
                    InsuranceList={cmsData?.data?.attributes?.Handsets_FAQ_List}
                  />
                </Grid>
              )}
            </Grid>
          )}
        </Grid>
        {loginModal && (
          <LoginModal
            enable={loginModal}
            setEnableModal={setLoginModal}
            onload={onMobileJourneyLogin}
            mobile
            saveLoginInfo={dispatch}
            registrationIncompleteModal={registrationIncompleteModal}
            mfaOtpModal={mfaOtpModal}
            mfaSuccessModal={mfaSuccessModal}
            setUserValue={setUserValue}
            setDelivery={setDelivery}
            setOtpUUID={setOtpUUID}
            showLoader={loader}
            setShowLoader={setLoader}
            loaderText='logging in'
            onLoadingDisablecta={onLoadingDisablecta}
            setOnLoadingDisablecta={setOnLoadingDisablecta}
            isR6Customer={isR6Customer}
            openAccountCheck={openAccountCheck}
          />
        )}
        {mfaOtpModal.value && (
          <MfaOtpModal
            mfaOtpModal={mfaOtpModal}
            delivery={delivery}
            userValue={userValue}
            errorModal={errorModal}
            otpUUID={otpUUID}
            setOtpUUID={setOtpUUID}
            mfaSuccessModal={mfaSuccessModal}
          />
        )}
        {mfaSuccessModal.value && <MfaSuccessModal mfaSuccessModal={mfaSuccessModal} />}
        {registrationIncompleteModal.value && (
          <EirRegistrationRequiredModal registrationIncompleteModal={registrationIncompleteModal} />
        )}
        {openJourneyPicker.value && (
          <EirJourneyPickerModal
            customerEligibility={customerEligibility}
            openJourneyPicker={openJourneyPicker}
            isStandaloneHandset
            graphql={graphql}
            cmsData={cmsData?.data}
            crossSellHandsetJourney={crossSellHandsetJourney}
            setShowSubscriptionModal={setShowSubscriptionModal}
            coMobileSubscriptions={coMobileSubscriptions}
            changeOfferJourney={changeOfferJourney}
          />
        )}
        {upgradeIneligible.value && (
          <MobileUpgradeIneligibleModal upgradeIneligible={upgradeIneligible} isStandaloneHandset />
        )}
        {openError && errorModalOccurence > errorModalMaxOccurence && (
          <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
        )}
        {errorModal.value && (
          <ErrorModal
            errorBBModal={errorModal}
            occurences={errorModalMaxOccurence}
            currentOccurence={errorModalOccurence}
            ctaMethod={onPageLoad}
          />
        )}
        {showSubscriptionModal && (
          <SubscriptionSelectionModal
            titleName={customerEligibility?.contactDetails?.firstName}
            disableAltcta={
              !customerEligibility?.crossSellEligibility?.serviceGroups?.filter(
                servicegrp => servicegrp.serviceGroup === 'MOBILE'
              )[0]?.eligible
            }
            subscriptions={coMobileSubscriptions}
            cmsData={cmsData?.data}
            changeOfferJourney={changeOfferJourney}
            mobileSubscription
            mobile
            // openKeepNumberCheck={openKeepNumberCheck}
            customerEligibility={customerEligibility}
            graphql={graphql}
            setShowSubscriptionModal={setShowSubscriptionModal}
          />
        )}
        {enableWebChat.value && <EirWebchatModal enableWebChat={enableWebChat} />}
        {isR6Customer.value && <UANErrorModal isHandset errorUANModal={isR6Customer} />}
        {openAbondonModal.value && (
          <EirAbondonJourney
            openAbondonModal={openAbondonModal}
            cmsData={cmsData}
            setClearJourney={setClearJourney}
            clearJourney={clearJourney}
            setJourneyType={setJourneyType}
            mobile
            setJourneyCrossOver={setJourneyCrossOver}
            journeyType={journeyType}
          />
        )}
        {openError && errorModalOccurence > errorModalMaxOccurence && (
          <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
        )}
        {errorModal.value && !showModal.value && !showSessionExpiredModal.value && (
          <ErrorModal
            errorBBModal={errorModal}
            occurences={errorModalMaxOccurence}
            currentOccurence={errorModalOccurence}
            ctaMethod={onLoadError ? onPageLoad : () => {}}
          />
        )}
      </main>
      <EirFooter cmsFooterData={cmsFooterData?.data} />
    </Stack>
  );
};

export default Handsets;
